import {RichText} from 'exceljs';
import {DateRange} from 'src/components/filter-header/typedefs';
import {CRITERIA_EXCEPTION_MESSAGE, EXCEL_CELL_MAX_LENGTH} from 'src/modules/downloads/cells/cells';
import {defaultCriteriaKeyFont} from 'src/modules/downloads/cells/fonts';
import {createDateRichText, createRichTextEntry} from 'src/modules/downloads/criteria/criteria';
import {getRichTextLength} from 'src/modules/downloads/utils/get-rich-text-length';
import {COLUMN_CAPTIONS, ColumnTypes} from 'src/modules/events/constants';
import {Filters} from 'src/modules/events/typedefs';

const FROM_SUFFIX = 'From';
const TO_SUFFIX = 'To';
const ALL_EVENTS_CRITERIA_MESSAGE = 'All Events';

const arrayToRichText = (key: string, array: string[]): RichText[] => {
    const keyCaption = COLUMN_CAPTIONS[key as ColumnTypes];
    return array.length ? createRichTextEntry(keyCaption, array.join(', ')) : [];
};

const dateToRichText = (key: string, dateRange: DateRange): RichText[] => {
    const keyCaption = COLUMN_CAPTIONS[key as ColumnTypes];

    const fromDateKeyCaption = createDateRichText(dateRange.from, keyCaption, FROM_SUFFIX);
    const toDateKeyCaption = createDateRichText(dateRange.to, keyCaption, TO_SUFFIX);

    return [...fromDateKeyCaption, ...toDateKeyCaption];
};

export const getCriteriaRichText = (filters: Filters) => {
    const richText = Object.entries(filters)
        .flatMap(([key, value]) => {
            return Array.isArray(value)
                ? arrayToRichText(key, value)
                : dateToRichText(key, value);
        });

    if (getRichTextLength(richText) >= EXCEL_CELL_MAX_LENGTH) {
        return [{text: CRITERIA_EXCEPTION_MESSAGE, font: defaultCriteriaKeyFont}];
    }

    return richText.length
        ? richText
        : [{text: ALL_EVENTS_CRITERIA_MESSAGE, font: defaultCriteriaKeyFont}];
};
